module.exports = __webpack_public_path__ + "img/768_app_download_qr.2709f8f8.svg";